<template>
  <div>
    <section class="section-padding bg-white">
      <div class="container-width">
        <div class="text-center mb-16">
          <h1 class="text-dark-900 mb-4">Meine Expertise</h1>
          <p class="text-xl text-dark-600 max-w-3xl mx-auto">
            Kernkompetenzen und Fähigkeiten, die ich in meine Projekte einbringe
          </p>
        </div>

        <div class="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          <div v-for="skill in skills" :key="skill.title" class="p-6 bg-gray-50 rounded-lg hover:shadow-lg transition-shadow">
            <div class="w-12 h-12 bg-primary-100 rounded-lg flex items-center justify-center mb-4">
              <span class="text-2xl text-primary-500">{{ skill.icon }}</span>
            </div>
            <h3 class="text-xl font-bold text-dark-900 mb-2">{{ skill.title }}</h3>
            <p class="text-dark-600">{{ skill.description }}</p>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script setup lang="ts">
useHead({
  title: 'Expertise - Kernkompetenzen | Enrico Reinsdorf UX Designer',
  meta: [
    { name: 'description', content: 'Kernkompetenzen: UX Design, Usability Engineering, User Research, Design Systems, Product Ownership, Workshop Facilitation und Team Leadership.' },
    { name: 'keywords', content: 'UX Design, Usability Engineering, User Research, Design System, Product Owner, Workshop Facilitation' }
  ]
})

const skills = [
  {
    icon: '🎨',
    title: 'User Experience Design',
    description: 'Gestaltung intuitiver und ansprechender Benutzererlebnisse durch nutzerzentrierte Design-Methoden.'
  },
  {
    icon: '🔍',
    title: 'Usability Engineering',
    description: 'Systematische Optimierung der Gebrauchstauglichkeit von digitalen Produkten.'
  },
  {
    icon: '👥',
    title: 'User Research & Testing',
    description: 'Durchführung von Nutzerstudien und Tests zur Validierung von Design-Entscheidungen.'
  },
  {
    icon: '🎯',
    title: 'Design Systems',
    description: 'Entwicklung und Pflege skalierbarer Design-Systeme für konsistente Produkterlebnisse.'
  },
  {
    icon: '📊',
    title: 'Product Ownership',
    description: 'Strategische Produktentwicklung mit Fokus auf Nutzernutzen und Geschäftsziele.'
  },
  {
    icon: '🤝',
    title: 'Workshop Facilitation',
    description: 'Moderation und Durchführung von Design Thinking und UX-Workshops.'
  },
  {
    icon: '👨‍💼',
    title: 'Team Leadership',
    description: 'Führung und Mentoring von UX-Teams in agilen Entwicklungsumgebungen.'
  }
]
</script>
